import React from "react";
import isEmpty from "lodash/isEmpty";
import { Row } from "jsxstyle";
import { withRouter } from "react-router-dom";
import useToast from "hooks/useToast";
import Card from "components/Card";
import Form from "components/Form";
import Button from "components/Button";
import useForm from "hooks/useForm";
import useAsync from "hooks/useAsync";
import isRequired from "validators/isRequired";
import minLength from "validators/minLength";
import saveABSDealService from "services/abs/saveABSDealService";
import TwoColumnFormLayout from "components/TwoColumnFormLayout";
import ABSFields from "./ABSFields";
import history from "browserHistory";

function ABSNewDealTab({ initialValues, onSubmit }) {
  const { showSuccess, showError } = useToast();

  const [fetch, pending] = useAsync({
    promiseFn: saveABSDealService,
    onData: (deal) => {
      showSuccess("ABS deal saved.");
      onSubmit(deal);
      history.push(`/abs/new/${deal.deal_code}/underwriters`);
    },
    onError: ({ data: { error, message } = {} }) => {
      console.error(error);
      const errorMessage =
        {
          duplicated_key: "Duplicate Deal Code",
        }[error] || message;
      showError(errorMessage);
    },
  });

  const { getValue, setValue, getError, submit } = useForm({
    initialValues: isEmpty(initialValues) ? {} : initialValues,
    validations: {
      deal_code: [isRequired, (value) => minLength(value, 6)],
      offering_type: [isRequired],
      deal_type: [isRequired],
      pricing_date: [isRequired],
      issuer: [isRequired],
      deal_amount: [isRequired],
    },
    onSubmit: (values) => fetch({ values }),
  });

  return (
    <Card>
      <TwoColumnFormLayout title="ABS Deal" size="sm">
        <Form onSubmit={submit}>
          <ABSFields
            getValue={getValue}
            setValue={setValue}
            getError={getError}
            isSubmitting={pending}
          />
          <Row justifyContent="flex-end" className="col-12">
            <Button
              type="submit"
              text={"Next"}
              intent="primary"
              onClick={() => {}}
              disabled={pending}
              loading={pending}
            />
          </Row>
        </Form>
      </TwoColumnFormLayout>
    </Card>
  );
}

export default withRouter(ABSNewDealTab);
